import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const user = 
{
    namespaced: true,
    state: {
        users: [],
        user: {},
        dashboardUserInfo: {},
        isAuthenticated: {}
    },
    mutations: {
        SET_USERS(state, data)
        {
            state.users = data
        },
        SET_USER(state, data)
        {
            state.user = data
        },
        SET_DASHBOARDUSERINFO(state, data)
        {
            state.dashboardUserInfo = data
        },
        SET_AUTH(state, data){
          state.isAuthenticated = data
        }
    },
    actions: {
      async login ({ commit, dispatch }, data) {
        try {
          let res = await axios.post(baseUrl + 'User/login', data, { withCredentials: true });
          
          if (res.status !== 200 && res.status !== 201) {
            console.error('Login failed:', res.data.message)
            return;
          }

          commit('SET_USER', res.data);
          await dispatch('authenticate');
        } catch (error) {
          console.error('Login failed:', error)
        }
      },

      async register ({ commit, dispatch }, data) {
        try {
          let res = await axios.post(baseUrl + 'User/register', data);
          
          if (res.status !== 200 && res.status !== 201) {
            console.error('Register failed:', res.data.message)
            return;
          }

          return res
          
        } catch (error) {
          console.error('Register failed:', error)
        }
      },
      
      getUserInfo ({ commit, dispatch },) {
        return axios 
        .get(baseUrl+'User/getUserInfo', { withCredentials: true })
        .then(res => {
            commit('SET_DASHBOARDUSERINFO', res.data);
          
        })
        .catch(error => console.log(error))
      },
      async logout ({ commit, dispatch }, data) {
        try {
          await axios.post(baseUrl + 'User/logout', data, { withCredentials: true })
          await dispatch('authenticate');
        } catch (error) {
          console.error('Logout failed:', error)
        }
      },
      async refreshUser ({ commit, dispatch },) {
        return axios 
        .get(baseUrl+'User/getUserInfo', { withCredentials: true })
        .then(res => {
            commit('SET_USER', res.data);
          
        })
        .catch(error => console.log(error))
      },
      async authenticate({ commit, state }) {          
        try {
          const res = await axios.get(baseUrl + 'User/isAuthenticated', { withCredentials: true });
          if (res.data) {
            commit('SET_AUTH', res.data);
            return res.data;
          } else {
            commit('SET_AUTH', false);
            return false;
          }
          
        } catch (error) {
          //console.error("Error when checking authentication", error);
          commit('SET_AUTH', false);
          return false;
        }
      },
    },
    getters: {
      isAdmin: state => {
        return state.user.roleId == 1;
      },
    }
}

export default user